import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { Field, Input } from '@availity/form';
import './RequestPreOrderEngagementAgreementModal.scss';
import InfoTooltip from '../../../components/info-tooltip/info-tooltip';

interface LocationFormProps {
    index: number;
}

const LocationForm = (props: LocationFormProps) => {
    return (
        <div
            key={props.index}
            className="border rounded pl-3 pr-3 pb-1 pt-1 mb-2">
            <h5 className="location-text">Location {props.index + 1}</h5>
            <Row>
                <Col md={4}>
                    <Field
                        type="text"
                        label="DBA Name"
                        name={`locations[${props.index}].dbaName`}
                        className="form-input"
                    />
                </Col>
                <Col md={4}>
                    <Field
                        type="text"
                        label="Street Address"
                        name={`locations[${props.index}].street`}
                        className="form-input"
                    />
                </Col>
                <Col md={4}>
                    <Field
                        type="text"
                        label="City"
                        name={`locations[${props.index}].city`}
                        className="form-input"
                    />
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Field
                        type="text"
                        label="State"
                        name={`locations[${props.index}].state`}
                        className="form-input"
                    />
                </Col>
                <Col md={4}>
                    <Field
                        type="text"
                        label="Zip Code"
                        name={`locations[${props.index}].zipCode`}
                        className="form-input"
                    />
                </Col>
                <Col md={4}>
                    <FormGroup for={`locations[${props.index}].fteDvms`}>
                        <Label>
                            FTE DVMs{' '}
                            <InfoTooltip text="FTE DVM = 36 clinical hours per week. For example, a DVM working 18 hours per week would be 0.5 FTE DVMS."></InfoTooltip>
                        </Label>
                        <Input
                            type="number"
                            name={`locations[${props.index}].fteDvms`}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </div>
    );
};

export default LocationForm;
